import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/travel/new/year/init', method: 'GET', params }, { interceptResultCode: false });
};

// 获取全服葫芦
export const hotNum = (params) => {
  return axios({
    url: '/travel/new/year/hot',
    method: 'GET',
    params: {}
  }, { interceptResultCode: false });
};

// 领取奖励
export const reward = (params) => {
  return axios({ url: '/travel/new/year/reward', method: 'GET', params }, { interceptResultCode: false });
};

// 完成任务
export const task = (params) => {
  return axios({ url: '/travel/new/year/make', method: 'POST', params }, { interceptResultCode: false });
};

// 助力
export const invite = (params) => {
  return axios({ url: '/travel/new/year/invite', method: 'GET', params }, { interceptResultCode: false });
};





// WEBPACK FOOTER //
// ./src/pages/travel/hlw/api.js